import {
  NEWS_EVENT_SET_SUBSCRIPTION,
  NEWS_EVENT_SET_LISTING,
  NEWS_EVENT_SET_THEMES,
  NEWS_EVENT_SET_TRIGGERS,
  NEWS_EVENT_SET_LANGUAGE,
  NEWS_EVENT_SET_ACTIVE,
} from "./consts";
import { newsEventSubscriptionDefault } from "./DefaultValue/newsEventSubscriptionDefault";

export const initState = {
  subscription: newsEventSubscriptionDefault,
  listing: {},
};

export const newsEventPageReducer = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case NEWS_EVENT_SET_SUBSCRIPTION:
      return {
        ...state,
        subscription: payload,
      };

    case NEWS_EVENT_SET_LISTING:
      return {
        ...state,
        listing: payload,
      };

    case NEWS_EVENT_SET_THEMES:
      return {
        ...state,
        subscription: { ...state.subscription, themes: payload },
      };

    case NEWS_EVENT_SET_TRIGGERS:
      return {
        ...state,
        subscription: { ...state.subscription, triggers: payload },
      };

    case NEWS_EVENT_SET_LANGUAGE:
      return {
        ...state,
        subscription: { ...state.subscription, language: payload },
      };

    case NEWS_EVENT_SET_ACTIVE:
      return {
        ...state,
        subscription: { ...state.subscription, active: payload },
      };

    default:
      return state;
  }
};
